const initializeCartUpdates = async () => {
  let cartData = await fetchCartData();

  // DOM Elements
  const editStickerButtons = document.querySelectorAll(".edit-cart-sticker-design");
  const quantitySelectors = document.querySelectorAll(".quantity-selector");

  for (const selector of quantitySelectors) {
    if (selector.dataset.initialized) continue;
    selector.dataset.initialized = "true";

    const quantityInput = selector.querySelector(".quantity-input");
    const quantityDropdown = selector.querySelector(".quantity-dropdown");
    const itemKey = quantityInput.dataset.key;
    const productId = selector.dataset.productId;
    const size = selector.dataset.size;

    if (!productId) {
      console.error("Product ID is missing.");
      continue;
    }

    const { sizeValue, width, height } = parseSize(size, selector);
    const calculator = await window.fetchCalculator(productId);
    if (!calculator) {
      console.error("No calculator found for product ID:", productId);
      continue;
    }

    const pricePerStickerMap = populateDropdown(quantityDropdown, calculator, sizeValue, width, height);

    quantityInput.addEventListener("click", (event) => {
      event.stopPropagation();
      toggleDropdown(quantityDropdown, quantityInput);
    });

    document.addEventListener("click", (event) => {
      if (!selector.contains(event.target)) toggleDropdown(quantityDropdown, quantityInput, false);
    });

    quantityDropdown.addEventListener("click", async (event) => {
      const selectedItem = event.target.closest(".quantity-item");
      if (!selectedItem) return;

      const selectedQuantity = selectedItem.dataset.value;
      quantityInput.value = selectedQuantity;

      const pricePerSticker = pricePerStickerMap[selectedQuantity];
      const item = cartData.items.find((i) => i.key === itemKey);
      if (!item) {
        console.error("Item not found in cart.");
        return;
      }

      await updateCartItem(itemKey, selectedQuantity, pricePerSticker);
      document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
      toggleDropdown(quantityDropdown, quantityInput, false);
    });
  }

  editStickerButtons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      const cartItemKey = button.dataset.itemKey;
      const item = cartData.items.find((i) => i.key === cartItemKey);
      if (!item) return console.error("Item not found for editing.");

      const productUrl = new URL(item.url, window.location.origin);
      productUrl.searchParams.delete("variant");
      productUrl.searchParams.set("itemKey", cartItemKey);
      window.location.href = productUrl.toString();
    });
  });
};

const fetchCartData = async () => {
  try {
    const response = await fetch("/cart.js");
    return response.ok ? response.json() : { items: [] };
  } catch (error) {
    console.error("Error fetching cart data:", error);
    return { items: [] };
  }
};

const parseSize = (size, selector) => {
  if (size === "Custom Size") {
    return {
      width: parseFloat(selector.dataset.width) || 0,
      height: parseFloat(selector.dataset.height) || 0,
      sizeValue: 0,
    };
  }

  const cleanedSize = size.replace(/[^0-9x.]/g, '');
  
  const sizeParts = cleanedSize.includes("x")
    ? cleanedSize
        .split("x")
        .map((part) => parseFloat(part.trim())) 
    : [];

  return sizeParts.length === 2
    ? { sizeValue: sizeParts[0] * sizeParts[1], width: 0, height: 0 }
    : { sizeValue: 0, width: 0, height: 0 };
};

const populateDropdown = (dropdown, calculator, sizeValue, width, height) => {
  dropdown.innerHTML = "";
  const priceMap = {};
  let firstPrice = 0;

  calculator.quantities.forEach(({ value }, index) => {
    const quantity = parseInt(value, 10);
    const basePrice = calculator.basePrices.find(bp => bp.quantity === quantity)?.value || 0;
    const squareInchPrice = calculator.squareInchPrices.find(sp => sp.quantity === quantity)?.value || 0;
    const totalPrice = window.evaluateFormula(calculator.totalPriceFormula, { sizeValue, width, height, quantity, basePrice, squareInchPrice });
    const pricePerSticker = (totalPrice / quantity).toFixed(2);
    priceMap[quantity] = pricePerSticker;

    if (index === 0) firstPrice = pricePerSticker;
    const savings = index !== 0 ? `- ${Math.round(((firstPrice - pricePerSticker) / firstPrice) * 100)}%` : "";
    const formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(pricePerSticker * quantity);
    
    const listItem = document.createElement("li");
    listItem.classList.add("quantity-item");
    listItem.dataset.value = value;
    listItem.innerHTML = `<div class="dropdown-item"><span class="quantity-label">${value}</span><span class="price-label">${formattedPrice}</span><span class="savings-label">${savings}</span></div>`;
    dropdown.appendChild(listItem);
  });

  return priceMap;
};

const toggleDropdown = (dropdown, input, show = null) => {
  const isVisible = show !== null ? show : dropdown.hidden;
  dropdown.hidden = !isVisible;
  input.setAttribute("aria-expanded", isVisible);
};

const updateCartItem = async (itemKey, quantity, pricePerSticker) => {
  try {
    const cartData = await fetchCartData();
    const item = cartData.items.find((i) => i.key === itemKey);
    if (!item) {
      console.error("Item not found in cart.");
      return;
    }

    const updatedProperties = {
      ...item.properties,
      "Quantity": quantity,
      "Price per Sticker": pricePerSticker,
      _pricePerSticker: (pricePerSticker * 100).toFixed(2),
    };

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: itemKey, quantity: parseInt(quantity, 10), properties: updatedProperties }),
    });

    if (!response.ok) throw new Error("Failed to update cart");
    return response.json();
  } catch (error) {
    console.error("Error updating cart:", error);
  }
};

window.initializeCartUpdates = initializeCartUpdates;
